var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bitcoin-icons:arrow-right-filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.483 4.47C13.6236 4.32955 13.8142 4.25066 14.013 4.25066C14.2117 4.25066 14.4024 4.32955 14.543 4.47L21.531 11.47C21.6715 11.6106 21.7503 11.8012 21.7503 12C21.7503 12.1988 21.6715 12.3894 21.531 12.53L14.543 19.53C14.4016 19.6667 14.2122 19.7424 14.0155 19.7408C13.8189 19.7391 13.6308 19.6604 13.4916 19.5214C13.3525 19.3824 13.2735 19.1943 13.2717 18.9977C13.2699 18.801 13.3454 18.6115 13.482 18.47L19.191 12.751L3 12.762C2.80109 12.7623 2.61022 12.6835 2.46938 12.543C2.32854 12.4026 2.24927 12.2119 2.249 12.013C2.24873 11.8141 2.3275 11.6232 2.46796 11.4824C2.60843 11.3415 2.79909 11.2623 2.998 11.262L19.192 11.252L13.481 5.53C13.3405 5.38937 13.2617 5.19875 13.2617 5C13.2617 4.80125 13.3405 4.61063 13.481 4.47",
    fill: "#6B39B2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRight);
export default __webpack_public_path__ + "static/media/icon_arrow_right.985d923291b729052aa3814d7a363c02.svg";
export { ForwardRef as ReactComponent };